// extracted by mini-css-extract-plugin
export default {"quadro":"Quadro_quadro__iRnIW","quadro__imgContainer":"Quadro_quadro__imgContainer__fxHNB","quadro__tituloContainer":"Quadro_quadro__tituloContainer__r2vVI"};